import React, { useContext, useState } from "react";
import { sum } from "lodash";
import { Material } from "../../../../../data/entities";
import CustomTable from "../../../../../shared/components/CustomTable";
import { StyledButton } from "../../../../MaterialOrder/Styled";
import { TableRow } from "@mui/material";
import { StyledTableCell } from "../../../../../shared/components/CustomTable/Styled";
import { StyledNavLink } from "../../../../../shared/styled/TableStyles";
import TextBox from "../../../../../shared/components/TextBox";
import IconButton from "../../../../../shared/components/IconButton";
import DeleteIcon from "../../../../../shared/svg/DeleteIcon";
import {
    SummaryTableCell,
    SummaryTableRow,
} from "../../../../Provider/create/Content/MaterialList/AddMaterialModal/Styled";
import { ContentWrapper, ProductButtonRow, ProductTableText } from "../../../../ProductOrder/single/Styled";
import { AddMaterialModal } from "./AddMaterialModal";
import DropdownMenuWithSearch from "../../../../../shared/components/DropdownMenuWithSearch";
import { formatCurrency, formatInternationalNumber, parseInternationalToNumber } from "../../../../../utils/format";
import { AuthenticationContext } from "../../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../../data/enums";
import { color } from "../../../../../shared/styles";
import { error } from "../../../../../utils/toast";

export const MaterialTableColumns = [
    { text: "Mã vật tư", icon: <></> },
    { text: "Tên vật tư", icon: <></> },
    { text: "Quy cách vật tư", icon: <></> },

    { text: "Hạng mục", icon: <></> },
    { text: "Ghi chú hạng mục", icon: <></> },
    { text: "Số lượng", icon: <></> },
    { text: "Định lượng", icon: <></> },

    { text: "Tổng định lượng", icon: <></> },
    { text: "Đơn vị", icon: <></> },

    { text: "Nhà cung cấp", icon: <></> },
    { text: "Giá cung cấp", icon: <></> },
    { text: "Dư liệu vật tư", icon: <></> },
    { text: "Giá dư liệu", icon: <></> },

    { text: "Ghi chú vật tư", icon: <></> },

    { text: "", icon: <></> },
];

const getMaterialTableColumns = (canViewPrice: boolean) => {
    if (!canViewPrice) {
        return MaterialTableColumns.filter(
            (item) => !["Giá cung cấp", "Giá dư liệu"].includes(item.text),
        );
    }
    return MaterialTableColumns;
};

interface ProductRowProps {
    item: any;
    idx: number;
    extraRowProps: any;
}

export const materialTypeOptions = [
    { text: "Vật tư chính", value: "Vật tư chính" },
    { text: "Vật tư phụ", value: "Vật tư phụ" },
];

export const MaterialRow = ({ item, extraRowProps }: ProductRowProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canEdit = [
        ROLE.MANAGER,
        ROLE.LOGISTIC_STAFF,
        ROLE.STORAGE_KEEPER,
        ROLE.FIRST_STORAGE_KEEPER,
        ROLE.SECOND_STORAGE_KEEPER,
    ].includes(role);
    const canViewPrice = [
        ROLE.MANAGER,
        ROLE.LOGISTIC_STAFF,
        ROLE.ACCOUNTANT_MANAGER,
    ].includes(role);

    const quantity = item.quantity !== undefined ? item.quantity : 0;
    const measurement = item.measurement !== undefined ? item.measurement : 0;

    const total_measurement =
        item.total_measurement !== undefined ? item.total_measurement : 0;

    const excess_quantity =
        item.excess_quantity !== undefined ? item.excess_quantity : 0;

    const excess_price =
        item.excess_price !== undefined ? item.excess_price : 0;

    const note = item.note !== undefined ? item.note : "";

    const category_note =
        item.category_note !== undefined ? item.category_note : "";

    const specification =
        item.specification !== undefined ? item.specification : "";

    const providerList = item.providers !== undefined ? item.providers : [];

    const materialType = item.category !== undefined ? item.category : "";

    const providerPrice =
        item.provider_price !== undefined
            ? formatCurrency(item.provider_price)
            : 0;

    const isMissingProvider = !item.provider_name && !item.isSummary;
    const shouldHighlightMissingProvider =
        extraRowProps.highlightMissingProvider && isMissingProvider;
    const backgroundColor = shouldHighlightMissingProvider
        ? color.status.DANGER_LIGHT
        : "";

    return !item.isSummary ? (
        <TableRow
            sx={{
                backgroundColor,
            }}
        >
            <StyledTableCell align="left">
                <StyledNavLink to={`/materials/${item.id}`}>
                    {item.material_code ? item.material_code : item.id}
                </StyledNavLink>
            </StyledTableCell>
            <StyledTableCell align="left">{item.name}</StyledTableCell>
            <SummaryTableCell align="left">
                <TextBox
                    text={specification}
                    onChangeText={(value: string) =>
                        extraRowProps.onUpdateSpecificationNote(
                            item.localId,
                            value,
                        )
                    }
                    disabled={!canEdit}
                />
            </SummaryTableCell>
            <SummaryTableCell align="left">{materialType}</SummaryTableCell>

            <StyledTableCell align="left">
                <TextBox
                    text={category_note}
                    onChangeText={(value: string) =>
                        extraRowProps.onUpdateMaterialCategoryNote(
                            item.localId,
                            value,
                        )
                    }
                    disabled={!canEdit}
                />
            </StyledTableCell>
            <StyledTableCell align="left">
                <TextBox
                    numeric
                    text={formatInternationalNumber(quantity ?? "")}
                    onChangeText={(value: string) => {
                        const n = parseInternationalToNumber(value, error);
                        if (!Number.isFinite(n)) return;
                        extraRowProps.onChangeMaterialQuantity(item.localId, n);
                    }}
                    disabled={!canEdit}
                />
            </StyledTableCell>
            <StyledTableCell align="left">
                <TextBox
                    numeric
                    text={formatInternationalNumber(measurement ?? "")}
                    onChangeText={(value: string) => {
                        const n = parseInternationalToNumber(value, error);
                        if (!Number.isFinite(n)) return;
                        extraRowProps.onChangeMeasurement(item.localId, n);
                    }}
                    disabled={!canEdit}
                />
            </StyledTableCell>
            <StyledTableCell align="left">
                <TextBox
                    numeric
                    text={formatInternationalNumber(total_measurement ?? "")}
                    onChangeText={(value: string) => {
                        const n = parseInternationalToNumber(value, error);
                        if (!Number.isFinite(n)) return;
                        extraRowProps.onChangeMaterialTotalMeasurement(item.localId, n);
                    }}
                    disabled={!canEdit}
                />
            </StyledTableCell>
            <StyledTableCell align="left">
                {item.measurement_unit}
            </StyledTableCell>
            <SummaryTableCell align="left">
                <DropdownMenuWithSearch
                    menuList={providerList}
                    menuText={item.provider_name || "Chọn nhà cung cấp"}
                    handleOnclickItem={(provider: any) =>
                        extraRowProps.onChangeProvider(item.localId, provider)
                    }
                    disabled={!canEdit}
                    style={
                        shouldHighlightMissingProvider
                            ? {
                                border: `1px solid ${color.status.FAIL}`,
                                borderRadius: "4px",
                                color: color.status.FAIL,
                            }
                            : {}
                    }
                />
            </SummaryTableCell>

            {canViewPrice && (
                <StyledTableCell align="left">{providerPrice}</StyledTableCell>
            )}

            <StyledTableCell align="left">
                <TextBox
                    numeric
                    text={formatInternationalNumber(excess_quantity ?? "")}
                    onChangeText={(value: string) => {
                        const n = parseInternationalToNumber(value, error);
                        if (!Number.isFinite(n)) return;
                        extraRowProps.onChangeExcessQuantity(item.localId, n);
                    }}
                    disabled={!canEdit}
                />
            </StyledTableCell>

            {canViewPrice && (
                <StyledTableCell align="left">
                    <TextBox
                        numeric
                        text={formatInternationalNumber(excess_price ?? "")}
                        onChangeText={(value: string) => {
                            const n = parseInternationalToNumber(value, error);
                            if (!Number.isFinite(n)) return;
                            extraRowProps.onChangeExcessPrice(item.localId, n);
                        }}
                        disabled={!canEdit}
                    />
                </StyledTableCell>
            )}

            <SummaryTableCell align="left">
                <TextBox
                    text={note}
                    onChangeText={(value: string) =>
                        extraRowProps.onUpdateMaterialNote(item.localId, value)
                    }
                    disabled={!canEdit}
                />
            </SummaryTableCell>

            <StyledTableCell align="left">
                <IconButton
                    onClick={() => extraRowProps.removeItem(item.localId)}
                    disabled={!canEdit}
                >
                    <DeleteIcon />
                </IconButton>
            </StyledTableCell>
        </TableRow>
    ) : (
        canViewPrice && (
            <SummaryTableRow>
                <SummaryTableCell align="left">{item.id}</SummaryTableCell>
                <SummaryTableCell align="left">{item.name}</SummaryTableCell>
                <SummaryTableCell align="left">{item.price}</SummaryTableCell>
                <SummaryTableCell align="left"></SummaryTableCell>
                <SummaryTableCell align="left"></SummaryTableCell>
                <SummaryTableCell align="left"></SummaryTableCell>
                <SummaryTableCell align="left"></SummaryTableCell>
                <SummaryTableCell align="left"></SummaryTableCell>
                <SummaryTableCell align="left"></SummaryTableCell>
                <SummaryTableCell align="left"></SummaryTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
            </SummaryTableRow>
        )
    );
};

interface MaterialListProps {
    materials: Material[];
    mergeMaterial: Function;
    isView?: boolean;
}

const MaterialStandard = ({
                              materials,
                              mergeMaterial,
                              isView,
                          }: MaterialListProps) => {
    const [isMaterialModalOpen, setIsMaterialModalOpen] = useState(false);
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canEdit = [
        ROLE.MANAGER,
        ROLE.LOGISTIC_STAFF,
        ROLE.STORAGE_KEEPER,
        ROLE.FIRST_STORAGE_KEEPER,
        ROLE.SECOND_STORAGE_KEEPER,
    ].includes(role);
    const canViewPrice = [ROLE.MANAGER, ROLE.LOGISTIC_STAFF].includes(role);

    const summaryMaterials = {
        id: `Tổng Định Mức Vật Tư`,
        price: canViewPrice
            ? formatCurrency(
                sum(
                    materials.map((item: any) => {
                        const price = Number(
                            ((item.provider_price || 0) * 1000000).toFixed(6),
                        );
                        const quantity = Number(
                            ((item.total_measurement || 0) * 1000000).toFixed(
                                6,
                            ),
                        );
                        const excess_quantity = Number(
                            ((item.excess_quantity || 0) * 1000000).toFixed(6),
                        );
                        const excess_price = Number(
                            ((item.excess_price || 0) * 1000000).toFixed(6),
                        );

                        const mainPrice = Number(
                            ((price * quantity) / 1000000000000).toFixed(6),
                        );
                        const excessTotal = Number(
                            (
                                (excess_price * excess_quantity) /
                                1000000000000
                            ).toFixed(6),
                        );

                        return mainPrice - excessTotal;
                    }),
                ),
            )
            : 0,
        isSummary: true,
    };

    const tableItems =
        materials.length === 0
            ? []
            : [...materials, summaryMaterials].map((item, idx) => ({
                ...item,
                localId: `${item.id}-${idx}`,
            }));

    const onRemoveMaterial = (localId: string) => {
        const removedMaterials = materials.filter(
            (material, idx) => `${material.id}-${idx}` !== localId,
        );
        mergeMaterial({ materials: removedMaterials });
    };

    const onChangeMaterialQuantity = (localId: string, quantity: any) => {
        const updatedMaterials = materials.map((material: any, idx: number) => {
            if (`${material.id}-${idx}` === localId)
                return { ...material, quantity: quantity };
            return material;
        });
        mergeMaterial({ materials: updatedMaterials });
    };

    const onChangeExcessQuantity = (localId: string, quantity: any) => {
        const updatedMaterials = materials.map((material: any, idx: number) => {
            if (`${material.id}-${idx}` === localId)
                return { ...material, excess_quantity: quantity };
            return material;
        });
        mergeMaterial({ materials: updatedMaterials });
    };

    const onChangeExcessPrice = (localId: string, quantity: any) => {
        const updatedMaterials = materials.map((material: any, idx: number) => {
            if (`${material.id}-${idx}` === localId)
                return { ...material, excess_price: quantity };
            return material;
        });
        mergeMaterial({ materials: updatedMaterials });
    };

    const onChangeProvider = (localId: string, provider: any) => {
        const updatedMaterials = materials.map((material: any, idx) => {
            if (`${material.id}-${idx}` === localId) {
                const selectedProvider = material.providers.find(
                    (p: any) => p.provider.name === provider.provider.name,
                );
                return {
                    ...material,
                    provider_name: provider.provider.name,
                    provider_price: selectedProvider
                        ? selectedProvider.price
                        : 0,
                };
            }
            return material;
        });
        mergeMaterial({ materials: updatedMaterials });
    };

    const onChangeMaterialTotalMeasurement = (
        localId: string,
        quantity: any,
    ) => {
        const updatedMaterials = materials.map((material: any, idx: number) => {
            if (`${material.id}-${idx}` === localId)
                return { ...material, total_measurement: quantity };
            return material;
        });
        mergeMaterial({ materials: updatedMaterials });
    };

    const onUpdateMaterialCategoryNote = (localId: string, note: string) => {
        const updatedMaterials = materials.map((material: any, idx) => {
            if (`${material.id}-${idx}` === localId)
                return { ...material, category_note: note };
            return material;
        });
        mergeMaterial({ materials: updatedMaterials });
    };

    const onUpdateMaterialNote = (localId: string, note: string) => {
        const updatedMaterials = materials.map((material: any, idx) => {
            if (`${material.id}-${idx}` === localId)
                return { ...material, note: note };
            return material;
        });

        mergeMaterial({ materials: updatedMaterials });
    };

    const onUpdateSpecificationNote = (localId: string, note: string) => {
        const updatedMaterials = materials.map((material: any, idx) => {
            if (`${material.id}-${idx}` === localId)
                return { ...material, specification: note };
            return material;
        });

        mergeMaterial({ materials: updatedMaterials });
    };

    const onChangeMeasurement = (localId: string, quantity: any) => {
        const updatedMaterials = materials.map((material: any, idx: number) => {
            if (`${material.id}-${idx}` === localId)
                return { ...material, measurement: quantity };
            return material;
        });
        mergeMaterial({ materials: updatedMaterials });
    };

    const onChangeMaterialType = (localId: string, type: string) => {
        const updatedMaterials = materials.map((material: any, idx) => {
            if (`${material.id}-${idx}` === localId) {
                return { ...material, category: type };
            }
            return material;
        });
        mergeMaterial({ materials: updatedMaterials });
    };

    return (
        <>
            {isMaterialModalOpen && !isView && (
                <AddMaterialModal
                    selectedMaterials={materials}
                    open={isMaterialModalOpen}
                    handleClose={() => setIsMaterialModalOpen(false)}
                    mergeMaterialOrder={mergeMaterial}
                />
            )}

            <ContentWrapper>
                <ProductTableText>Danh sách vật liệu</ProductTableText>

                <CustomTable
                    itemList={tableItems}
                    RowElement={MaterialRow}
                    TableColumns={getMaterialTableColumns(canViewPrice)}
                    extraRowProps={{
                        removeItem: onRemoveMaterial,
                        onChangeMaterialQuantity,
                        onChangeProvider,
                        onUpdateMaterialNote,
                        onChangeMaterialType,
                        onUpdateMaterialCategoryNote,
                        onChangeExcessQuantity,
                        onChangeExcessPrice,
                        onUpdateSpecificationNote,
                        onChangeMeasurement,
                        onChangeMaterialTotalMeasurement,
                    }}
                />

                {materials.length === 0 && "Không có vật tư được chọn"}
                {!isView && canEdit && (
                    <ProductButtonRow>
                        <StyledButton
                            variant="contained"
                            onClick={() => setIsMaterialModalOpen(true)}
                        >
                            Thêm vật tư
                        </StyledButton>
                    </ProductButtonRow>
                )}
            </ContentWrapper>
        </>
    );
};

export default MaterialStandard;
